import { createSlice } from "@reduxjs/toolkit";
import { getAllNotificationsAsync } from "./notificationApi";

interface NotificationState {
  notificationList: any[];
  countNotification: number;
  loading: boolean;
}

const initialState: NotificationState = {
  notificationList: [],
  countNotification: 0,
  loading: false,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllNotificationsAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllNotificationsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.notificationList = action.payload.data;
        state.countNotification = action.payload.length;
      })
      .addCase(getAllNotificationsAsync.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default notificationSlice.reducer; 